import React from "react";
import { gql, useMutation } from "@apollo/client";
import Button from "../../../../../Button";
import { graphql, useLazyLoadQuery } from "react-relay";
import StatTable from "../../../../../StatTable";

const UPLOAD_PROJECTIONS = gql`
  mutation NascarProjectionsTable($series: String!, $csv: Upload!) {
    uploadNascarProjections(series: $series, csvFile: $csv) {
      success
    }
  }
`;

const NASCAR_PROJECTIONS = graphql`
  query NascarProjectionsTableQuery($series: String!) {
    whoAmI {
      groups {
        name
      }
      username
    }

    nascarProjectionHeaders(series: $series) {
      headerName
      headerSlug
      sortDescFirst
    }

    nascarProjectionRow(series: $series) {
      rowJson
    }
  }
`;

export default function NascarProjectionsTable(props) {
  const queryData = useLazyLoadQuery(NASCAR_PROJECTIONS, {
    series: props.series,
  });

  const [loading, setLoading] = React.useState(false);
  const [file, setFile] = React.useState(undefined);

  const [uploadProjections] = useMutation(UPLOAD_PROJECTIONS);

  function onFileUpload(e) {
    e.preventDefault();

    setFile(e.target.files[0]);
  }

  function onSubmit(e) {
    e.preventDefault();

    if (!file) {
      return;
    }

    setLoading(true);

    uploadProjections({ variables: { series: props.series, csv: file } })
      .then(() => {
        setLoading(false);
        alert("Projections uploaded successfully. Refresh the page.");
      })
      .catch(() => {
        setLoading(false);
        alert("Something went wrong.");
      });
  }

  if (!queryData.nascarProjectionRow) {
    return null;
  }

  let data =
    queryData.nascarProjectionRow.length > 0
      ? queryData.nascarProjectionRow.map((row) => {
          const j = JSON.parse(row.rowJson);
          return JSON.parse(j);
        })
      : [];

  let headers = React.useMemo(() => {
    return queryData.nascarProjectionHeaders.map((row) => {
      return {
        Header: row.headerName,
        accessor: row.headerSlug,
        sortDescFirst: row.sortDescFirst,
      };
    });
  }, [queryData]);

  return (
    <div>
      <div>
        <h1>Upload Projections</h1>
        <label htmlFor="csv-file">CSV: </label>
        <input id="csv-file" type="file" onChange={onFileUpload} />
        <br />
        <br />
        <Button form={true} onClick={onSubmit} style={{ margin: "inherit" }}>
          Submit
        </Button>
      </div>

      {data.length > 0 ? (
        <StatTable columns={headers} data={data} heatMap={true} />
      ) : (
        <p>No projections have been posted at this time.</p>
      )}
    </div>
  );
}
